import { useEffect } from "react";

export default function RedirectPage() {
  useEffect(() => {
    // Redirect to the target website after component mounts
    window.location.href = "https://subscribe.dailyprincetonian.com/";
  }, []);

  return (
    <p>
      If you are not redirected automatically,{" "}
      <a href="https://subscribe.dailyprincetonian.com/">click here</a>
    </p>
  );
}
